var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17 6c.56 0 1 .43 1 1 0 .55-.45 1-1 1-.57 0-1-.45-1-1 0-.57.43-1 1-1zM0 0v9c0 2.96 2.19 5.5 5.14 5.91C5.76 17.92 8.42 20 11.5 20a6.5 6.5 0 0 0 6.5-6.5V9.81c1.16-.42 2-1.52 2-2.81 0-1.66-1.34-3-3-3s-3 1.34-3 3c0 1.29.84 2.4 2 2.81v3.6c0 2.5-2 4.5-4.5 4.5-2 0-3.68-1.21-4.28-3.01C10 14.3 12 11.8 12 9V0H8v3h2v6c0 2.21-1.79 4-4 4s-4-1.79-4-4V3h2V0H0z", fill: "#142A39" })
  );
});